(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-dock"] && !Shopify.designMode) return;
  try {
    
  function fillPdpDockSlots() {
    document.querySelectorAll("[data-pdp-fill]").forEach((el) => {
      const src = document.querySelector(`template[data-pdp-source="${el.dataset.pdpFill}"]`);
      if (!src || !src.content || !src.content.firstChild) return;
      const host = el.parentElement;
      el.replaceWith(src.content.cloneNode(true));
      if (host) {
        host.querySelectorAll("[data-pdp-sale-fallback], [data-pdp-shipping-fallback]").forEach((fallback) => fallback.remove());
      }
    });
  }
  fillPdpDockSlots();
  document.addEventListener("shopify:section:load", fillPdpDockSlots);

  } catch(e) { console.error(e); }
})();
})();
